import React from 'react'

interface CheckProps {
  value: number | string
  onChange?: (_e: React.ChangeEvent<HTMLInputElement>) => void
  checked?: boolean
  defaultChecked?: boolean
  label?: string
}

const Check = ({
  value,
  onChange,
  checked,
  defaultChecked,
  label,
}: CheckProps) => {
  return (
    <div className="flex items-center">
      <input
        checked={checked}
        className={
          `h-4 w-4 cursor-pointer rounded border-gray-500` +
          ` text-slate-600 focus:bg-transparent focus:ring-transparent`
        }
        defaultChecked={defaultChecked}
        name={''}
        onChange={(e) => {
          if (onChange) onChange(e)
        }}
        type="checkbox"
        value={value}
      />
      {label && <span className="ml-2">{label}</span>}
    </div>
  )
}

export default Check
